export const API_PATH_ApiDeviceMgmtSettingsPut = '/services/devices-mgtm/apiDeviceMgmtSettingsPut';
